<div class="grow bg-muted" style="height: 1px"></div>
<div
  class="text-sm uppercase tracking-wider"
  style="padding: 0 10px; color: rgba(0, 0, 0, 0.45)">
  {{ text }}
</div>
<div class="grow bg-muted" style="height: 1px"></div>
